import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const MonthlyProfitsChart = ({
  balance = 0,
  activeInvestment = 0,
  expectedReturn = 0,
}) => {
  const total = balance + activeInvestment + expectedReturn || 1;

  const data = [
    {
      name: "Balance",
      raw: balance,
      value: parseFloat(((balance / total) * 100).toFixed(1)),
      color: "#a4b0f5",
    },
    {
      name: "Active",
      raw: activeInvestment,
      value: parseFloat(((activeInvestment / total) * 100).toFixed(1)),
      color: "#bdd2b6",
    },
    {
      name: "Returns",
      raw: expectedReturn,
      value: parseFloat(((expectedReturn / total) * 100).toFixed(1)),
      color: "#fce38a",
    },
  ];

  return (
    <div className="bg-white py-6 px-2 rounded-[24px] shadow-sm border border-gray-50 w-full max-w-md">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-[16px] font-bold text-gray-800 leading-tight">
            Portfolio Overview
          </h3>
          <p className="text-[11px] text-gray-400 font-medium mt-1">
            Balance · Active · Returns
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="relative w-[180px] h-[180px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={85}
                paddingAngle={0}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    stroke="none"
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-[11px] text-gray-400 font-medium">Total</span>
            <span className="text-[15px] font-bold text-gray-800">
              ${(balance + activeInvestment + expectedReturn).toLocaleString()}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-4 mt-6 md:mt-0 md:pl-6 w-full md:w-auto">
          {data.map((item, index) => (
            <div key={index} className="flex flex-col">
              <span className="text-[10px] text-gray-400 uppercase font-bold tracking-wider">
                {item.name}
              </span>
              <span className="text-[18px] font-extrabold text-gray-800 leading-none">
                ${item.raw.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MonthlyProfitsChart;
